# frozen_string_literal: true

module Engine
  module Entity
    def company?
      false
    end

    def corporation?
      false
    end

    def minor?
      false
    end

    def system?
      false
    end

    def operator?
      false
    end

    def player?
      false
    end

    def receivership?
      false
    end

    def share_pool?
      false
    end

    def closed?
      false
    end
  end
end
